import { trackEvent } from "@garantidos/utils/tracking"

const useFinishedContent = () => {
  const segmentMarkeplaceInfo = [
    "crossell-cardclick-proposal-cgi",
    "crossell-shopping-proposal-cgi",
    "crossell-vehicles-proposal-cgi"
  ]
  const ga4MarkeplaceInfo = [
    "envio-proposta-sucesso-peça-ja-o-seu",
    "envio-proposta-sucesso-confira-agora",
    "envio-proposta-sucesso-quero-carro-novo"
  ]

  const handleMarketplaceCallback = (product, index) => {
    const eventObject = {
      ga: {
        action: "Simulacao",
        label: `BTN:Simulacao:${product}`
      },
      ga4: {
        customPath:
          "credito/cgimovel/quitado/contratacao/env-proposta/envio-proposta-sucesso",
        implementationTeam: "cgi:v01",
        eventName: "click",
        detail: ga4MarkeplaceInfo[index]
      },
      segment: `${segmentMarkeplaceInfo[index]}`
    }

    trackEvent(eventObject)

    const newSegmentTracking = {
      segment: {
        event: "marketplace interaction",
        data: {
          product,
          productOrder: index + 1
        }
      }
    }

    trackEvent(newSegmentTracking)
  }

  return { handleMarketplaceCallback }
}

export default useFinishedContent
